import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';

// 导入 reducers
import authReducer from './reducers/authReducer';
import tasksReducer from './reducers/tasksReducer';
import uiReducer from './reducers/uiReducer';
import orderReducer from './reducers/orderReducer';
import inviteReducer from './reducers/inviteReducer';

// 合并所有 reducers
const rootReducer = combineReducers({
  auth: authReducer,
  tasks: tasksReducer,
  ui: uiReducer,
  order: orderReducer,
  invite: inviteReducer
});

// 创建 Redux store
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store; 